module.exports = __webpack_public_path__ + "static/media/person-moving.63f701d9.gif";